import { Svgicon } from 'components/Svgicon/Svgicon';
import {
  type FC,
} from 'react';

export const EmptyDocumentCategory: FC = () => {
  return (
    <div className='flex size-full max-w-[90rem] flex-col items-center justify-center gap-[1.25rem] rounded-medium bg-white-999 p-[1rem]'>
      <Svgicon className='size-10' id='empty-document-1f' />
      <div className='text-title-4 font-semibold'>No documents yet</div>
    </div>
  );
};
